import { useTranslation } from 'react-i18next';
import { createI18n, Language } from '@flicent/fieldpulse-react-component-library-frontend';

import en from './locales/en.json';

export const { instance: appI18n, loadLocale: loadAppLocale } = createI18n({
  ns: 'custom_form',
  initialResources: en,
  importBundle: (lng: Language) => import(`./locales/${ lng }.json`),
});

export const useCustomFormTranslation = () => useTranslation('custom_form', { i18n: appI18n });